import { Breadcrumb } from "antd"
import rightArrowIcon from "assets/svg/chevron-right.svg"

interface CustomBreadCrumbProps {
  onClick: () => void
  prefixName: string
  suffixName: string
}
const CustomBreadCrumb: React.FC<CustomBreadCrumbProps> = ({
  onClick,
  prefixName,
  suffixName,
}) => {
  return (
    <Breadcrumb
      separator={
        <img
          src={rightArrowIcon}
          width={15}
          height={15}
          alt="separator"
        />
      }
      items={[
        {
          title: (
            <p
              className="text-slate-300 hover:underline hover:cursor-pointer"
              onClick={onClick}
            >
              {prefixName}
            </p>
          ),
        },
        {
          title: <p className="capitalize">{suffixName}</p>,
        },
      ]}
    />
  )
}

export default CustomBreadCrumb
